import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default function LoadingSpinner({ className }) {
  return (
    <div className={classNames('gn-spinnerWrapper', className)}>
      <div className="gn-spinner" />
    </div>
  );
}

LoadingSpinner.propTypes = {
  className: PropTypes.string,
};
